import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogEventConfirmOverlayComponent } from '@app/main/leak-detection/dialogs/dialog-event/components/dialog-event-confirm-overlay/dialog-event-confirm-overlay.component';
import { DialogEventOverlay } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-overlay.enum';

@Component({
  selector: 'gc-dialog-hide-event',
  templateUrl: './dialog-hide-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DialogEventConfirmOverlayComponent],
})
export class DialogHideEventComponent {
  private readonly ref = inject(DynamicDialogRef);

  protected readonly Overlay = DialogEventOverlay;

  public close(confirmed = false): void {
    this.ref.close(confirmed);
  }
}
